import { render, staticRenderFns } from "./CustomerITRQ.vue?vue&type=template&id=85ebe9d6&scoped=true&"
import script from "./CustomerITRQ.vue?vue&type=script&lang=ts&"
export * from "./CustomerITRQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ebe9d6",
  null
  
)

export default component.exports